import { Avatar as MuiAvatar, styled } from '@mui/material';

const Avatar = styled(MuiAvatar)`
  border: ${({ selected, theme }) => (selected ? `2px solid ${theme.palette.primary.main}` : 'none')};
`;

export default Avatar;
